import React from 'react'
import MediaLibraryContent, {
	MediaLibraryContentProps,
} from '@/components/MediaLibrary/MediaLibraryContent'
import { MediaLibraryProvider } from './MediaLibraryContext'

import { DEFAULT_ACCEPT } from './utils/constants'
import { BaseMediaLibraryProps } from './types'

export type MediaLibraryProps = BaseMediaLibraryProps &
	MediaLibraryContentProps

const MediaLibrary = ({
	data,
	folders,
	title,
	selectActions,
	bulkSelectActions,
	search,
	pagination,
	onRefreshClick,
	onUpload,
	onSelect,
	onCloseMediaPreview,
	loading = false,
	accept = DEFAULT_ACCEPT,
	preSelectedFiles,
}: MediaLibraryProps) => {
	return (
		<MediaLibraryProvider
			data={data}
			folders={folders}
			title={title}
			loading={loading}
			selectActions={selectActions}
			bulkSelectActions={bulkSelectActions}
			onRefreshClick={onRefreshClick}
			onUpload={onUpload}
			onSelect={onSelect}
			onCloseMediaPreview={onCloseMediaPreview}
			accept={accept}
			preSelectedFiles={preSelectedFiles}
		>
			<MediaLibraryContent search={search} pagination={pagination} />
		</MediaLibraryProvider>
	)
}

export default MediaLibrary
